import { createHttpLink, from } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { graphqlPath, graphqlUnauthPath } from '$extensionSrc/consts/urlConsts'
import { INSTALLATION_ID_HEADER_NAME } from '$extensionSrc/utils/enums'

import {
  getJwtAccessCsrfHeader,
  getUnauthCsrfHeader,
  getInstallationId,
} from './utils/fetch'

const authHttpLink = createHttpLink({
  uri: graphqlPath,
})

const unauthHttpLink = createHttpLink({
  uri: graphqlUnauthPath,
})

const authCsrfLink = setContext(async (operation, prevContext) => {
  const { headers } = prevContext

  let updatedHeaders = { ...(headers || {}) }

  const [name, value] = getJwtAccessCsrfHeader()

  if (name && value) {
    updatedHeaders = {
      ...updatedHeaders,
      [name]: value,
    }
  }

  return { headers: updatedHeaders }
})

const unauthCsrfLink = setContext(async (operation, prevContext) => {
  const { headers } = prevContext

  let updatedHeaders = { ...(headers || {}) }

  const [name, value] = getUnauthCsrfHeader()

  if (name && value) {
    updatedHeaders = {
      ...updatedHeaders,
      [name]: value,
    }
  }

  return { headers: updatedHeaders }
})

const installationIdLink = setContext(async (operation, prevContext) => {
  const { headers } = prevContext

  let updatedHeaders = { ...(headers || {}) }

  const installationId = getInstallationId()
  if (installationId) {
    updatedHeaders = {
      ...updatedHeaders,
      [INSTALLATION_ID_HEADER_NAME]: installationId,
    }
  }

  return { headers: updatedHeaders }
})

export const authLink = from([installationIdLink, authCsrfLink, authHttpLink])
export const unauthLink = from([
  installationIdLink,
  unauthCsrfLink,
  unauthHttpLink,
])
